
<div class="filters-container" [formGroup]="filtersForm">
    <div class="tw-flex tw-items-center tw-justify-between tw-px-2 tw-shrink-0">
        <h3 class="tw-text-lg tw-font-semibold tw-tracking-tight tw-my-0">{{'EXTENDED_TABLE.TITLE.CUSTOM_FILTER' | translate}}</h3>
        <div class="tw-flex tw-items-center tw-gap-1">
            @if(filterApplied && !hideResetFilterIcon) {
                <button mat-icon-button (click)="resetFilter(true)" aria-label="Reset custom filters">
                    <mat-icon>filter_alt_off</mat-icon>
                </button>
            }
            <button mat-icon-button (click)="toggleSidenav()" aria-label="Close filter sidenav">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="sidenav-section top-section tw-shrink-0">
        <div class="collapsible-content">
            <mat-form-field appearance="outline">
                <mat-label>{{'EXTENDED_TABLE.TITLE.SAVED_FILTERS' | translate}}</mat-label>
                <mat-select class="saved-filters"
                    [formControl]="savedFiltersControl"
                    (selectionChange)="onSelectionChange()"
                >
                    @for (filter of savedFilters; track filter.name) {
                        <mat-option [value]="filter.name">{{ filter.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <div class="container-btn-near-field">
                <button mat-icon-button (click)="resetFilter(true)" aria-label="Add new filter">
                    <mat-icon>add_circle</mat-icon>
                </button>
            </div>

        </div>
    </div>
    
    <div #scrollContainer class="sidenav-section middle-section">
        <div>
            <div class="container-title-actions">
                <h4 class="tw-my-2">{{filterEditingSectionTitle | translate}}</h4>
                <div>
                    @if(savedFiltersControl.value) {
                        <button mat-icon-button (click)="openDeleteDialog()" aria-label="Close filter sidenav">
                            <mat-icon>delete_forever</mat-icon>
                        </button>
                    }
                    <button mat-icon-button (click)="saveFilter()" aria-label="Reset custom filters"
                        [disabled]="filterNameControl.invalid" (focus)="scrollToTarget($event)">
                        <mat-icon>check</mat-icon>
                    </button>
                </div>
            </div>
            <div>
                <mat-form-field appearance="fill" class="tw-w-full !tw-rounded-md">
                    <mat-label>{{'EXTENDED_TABLE.TITLE.NAME_FILTER_LABEL' | translate}}</mat-label>
                    <input matInput [formControl]="filterNameControl" type="text" required (focus)="scrollToTarget($event)"/>
                    @if(filterNameControl.hasError('required') && filterNameControl.touched) {
                        <mat-error>{{'NG_MESSAGES.REQUIRED_FIELD' | translate}}</mat-error>
                    }
                </mat-form-field>
            </div>
        </div>

        <mat-accordion multi class="tw-flex tw-flex-col tw-pb-5">
            @for(filter of customFilters; track $index) {
                <mat-expansion-panel #panel class="!tw-shadow-md !tw-border !tw-border-slate-400 !tw-rounded-md tw-overflow-hidden" 
                        [class.active-filter]="getSelectedCount(filter.field) > 0">
                    <mat-expansion-panel-header class="!tw-px-4">
                        <mat-panel-title class="!tw-font-semibold !tw-text-slate-700">
                        {{filter.name}}
                        </mat-panel-title>
                        <mat-panel-description class="!tw-justify-end">
                            {{ getSelectionSummary(filter.field) }}
                        </mat-panel-description>
                    </mat-expansion-panel-header>
                        
                    <ng-container [formGroupName]="filter.field">
                        <div class="tw-sticky tw-top-0 tw-z-10 tw-bg-[var(--background-color-expansion-panel)] tw-pt-2 tw-pb-1">
                            <mat-form-field appearance="fill" class="tw-w-full dense-search-field">
                                <mat-icon matPrefix class="tw-opacity-50 tw-scale-75">search</mat-icon>
                                <input matInput type="text" 
                                    formControlName="search" 
                                    autocomplete="off"
                                    [placeholder]="('EXTENDED_TABLE.PLACEHOLDER.FILTER' | translate) + ' ' + filter.name.toLowerCase()"
                                    (input)="onSearchInput(filter.field, panel)"
                                >
                                <button matSuffix mat-icon-button aria-label="Clear" 
                                        *ngIf="filtersForm.get([filter.field, 'search'])?.value"
                                        (click)="clearSearchField(filter.field)"
                                        class="tw-scale-75">
                                    <mat-icon>close</mat-icon>
                                </button>
                            </mat-form-field>
                        </div>

                        <div class="tw-flex tw-flex-col tw-gap-1" formArrayName="options">
                            @for(item of filteredOptionsMap.get(filter.field)?.(); track item.option.id) {
                                <div [formGroupName]="item.realIndex" 
                                    class="checkbox-wrapper tw-transition-all tw-duration-300">
                                    <mat-checkbox 
                                        formControlName="selected" 
                                        (change)="checkboxSelectionChange($event, filter.field)" 
                                        class="tw-w-full">
                                        
                                        <span [class.font-bold]="item.selected">
                                        {{ item.option.name }}
                                        </span>
                                    </mat-checkbox>
                                </div>
                            }
                        </div>

                    </ng-container>
                </mat-expansion-panel>
            }
        </mat-accordion>
    </div>
</div>